import * as yup from "yup";

const phoneRegExp = /^(?:50|51|52|54|55|56|58|2|3|4|6|7|9)\d{7}$/;

const numbersRegExp = /^\d+$/;
const arabicEnglishRegExp = /^[a-zA-Z\u0600-\u06FF ]*$/;
const arabicEnglishNumbersRegExp = /^[a-zA-Z\u0600-\u06FF0-9 ]*$/;
const nationalIdRegex =
  /^([1-9]{1})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})[0-9]{3}([0-9]{1})[0-9]{1}$/;
// Schema factory function
const fileSchema = yup
  .mixed()
  .test(
    "fileSize",
    "Should be less than 5MB.",
    (value) => !value || (value && value.size <= 5 * 1024 * 1024)
  )
  .test(
    "fileType",
    "Invalid file type. Please upload the correct file type",
    (value) =>
      !value ||
      (value && value.type === "application/pdf") ||
      value?.type.startsWith("image/")
  );

export const EnSchema = (selectedProduct) => {
  return yup.object().shape({
    name: yup
      .string()
      .min(3, "At least 3 characters long")
      .trim()
      .matches(arabicEnglishRegExp, "Please provide correct name.")
      .required("Please fill the required field"),
    mobilePhone: yup
      .string()
      .min(9, "Must be exactly 9 digits")
      .max(9, "Must be exactly 9 digits")
      .matches(
        phoneRegExp,
        "Phone number must start with (50/51/52/54/55/56/58) directly"
      )
      .required("Required"),
    email: yup
      .string()
      .email("Please provide correct email.")
      .required("Please fill the required field"),
    product: yup.string().required("Please fill the required field"),
    // Conditionally required fields
    ...((selectedProduct === "auto" || selectedProduct === "trucks") && {
      category: yup.string().required("Please fill the required field"),
      amount: yup
        .string()
        .matches(numbersRegExp, "Please provide correct car amount")
        .required("Please fill the required field"),
    }),
    ...(selectedProduct === "mortgage" && {
      mortgageType: yup.string().required("Please fill the required field"),
    }),
    passportUrl: fileSchema.required("Please fill the required field"),
    workPermitUrl: fileSchema.notRequired(),
    hrLetter: fileSchema.notRequired(),
    bankStatementUrl: fileSchema.notRequired(),
    EgyptAddress: yup.string().required("Please fill the required field"),
    message: yup
      .string()
      .min(3, "At least 3 characters long")
      .max(800, "at most 800 characters long")
      .trim(),
    preferredCallingTime: yup.string().required("Required"),
  });
};

